module.exports = __webpack_public_path__ + "img/trash.22cdab84.svg";